import { Section } from '../models';
import { InstallationSeries } from 'app/shared/models/location-details';
import { InstallationConfigState, InstallationTypeSectionIds } from './common.models';
import { pipeInstallationConfig } from './echo/installation-types/pipe';
import { weirInstallationConfig } from './echo/installation-types/weir';
import { flumeInstallationConfig } from './echo/installation-types/flume';
import { channelInstallationConfig } from './echo/installation-types/channel';
import { channelInstallationConfig as foresiteUlChannelConfig } from './foresite-ul/installation-types/channel';
import { elevationInstallationConfig } from './foresite-ul/installation-types/elevation';
import { MonitorSeriesNames } from '../../location-card.constants';

export function resolveInstallationSectionId(installationSeries: number): string | undefined {
    if (installationSeries >= InstallationSeries.Pipe && installationSeries < InstallationSeries.Weir) {
        return InstallationTypeSectionIds.Pipe;
    } else if (installationSeries >= InstallationSeries.Weir && installationSeries < InstallationSeries.Flume) {
        return InstallationTypeSectionIds.Weir;
    } else if (installationSeries >= InstallationSeries.Flume && installationSeries < InstallationSeries.Channel) {
        return InstallationTypeSectionIds.Flume;
    } else if (installationSeries === InstallationSeries.Channel) {
        return InstallationTypeSectionIds.Channel;
    } else if (installationSeries === InstallationSeries.Elevation) {
        return InstallationTypeSectionIds.Elevation;
    }
    return undefined;
}

export function resolveInstallationSection(installationSeries: number, state: InstallationConfigState, monitorSeriesName?: string): Section | undefined {
    if (installationSeries >= InstallationSeries.Pipe && installationSeries < InstallationSeries.Weir) {
        return pipeInstallationConfig(state);
    } else if (installationSeries >= InstallationSeries.Weir && installationSeries < InstallationSeries.Flume) {
        return weirInstallationConfig(state);
    } else if (installationSeries >= InstallationSeries.Flume && installationSeries < InstallationSeries.Channel) {
        return flumeInstallationConfig(state);
    } else if (installationSeries === InstallationSeries.Channel) {
        // ForeSite-UL is special and has height but does not have number of rows in its Channel standard installation type,
        // so load its configuration specifically
        if (monitorSeriesName?.toLowerCase() === MonitorSeriesNames.ForeSITE_UL.toLowerCase()) {
            return foresiteUlChannelConfig(state);
        }
        return channelInstallationConfig(state);
    } else if (installationSeries === InstallationSeries.Elevation) {
        return elevationInstallationConfig(state);
    }
    return undefined;
}
